import { render } from "./TheNotificationBanner.vue?vue&type=template&id=686276e4&scoped=true"
import script from "./TheNotificationBanner.vue?vue&type=script&lang=js"
export * from "./TheNotificationBanner.vue?vue&type=script&lang=js"

import "./TheNotificationBanner.vue?vue&type=style&index=0&id=686276e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686276e4"]])

export default __exports__